/* tslint:disable */
/* eslint-disable */
/**
 * Eclipse ReST API
 * This is a RESTful web service using JSON as the data transfer model. The service covers all the tenant facing functionality in Eclipse
 *
 * OpenAPI spec version: 3.0.0
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
// Some imports not used depending on template conditions
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';
import { EclipseTransfer } from '../models';
/**
 * MWalletTransfersApi - axios parameter creator
 * @export
 */
export const MWalletTransfersApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Do a wallet transfer
         * @param {number} tenantId 
         * @param {EclipseTransfer} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsTenantIdWalletsTransfersPost: async (tenantId: number, body?: EclipseTransfer, options: any = {}): Promise<RequestArgs> => {
            // verify required parameter 'tenantId' is not null or undefined
            if (tenantId === null || tenantId === undefined) {
                throw new RequiredError('tenantId','Required parameter tenantId was null or undefined when calling tenantsTenantIdWalletsTransfersPost.');
            }
            const localVarPath = `/tenants/{tenantId}/wallets/transfers`
                .replace(`{${"tenantId"}}`, encodeURIComponent(String(tenantId)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, 'https://example.com');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication JWTBearerAuthorisation required

            localVarHeaderParameter['Content-Type'] = 'application/json';

            const query = new URLSearchParams(localVarUrlObj.search);
            for (const key in localVarQueryParameter) {
                query.set(key, localVarQueryParameter[key]);
            }
            for (const key in options.query) {
                query.set(key, options.query[key]);
            }
            localVarUrlObj.search = (new URLSearchParams(query)).toString();
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            const needsSerialization = (typeof body !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(body !== undefined ? body : {}) : (body || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search + localVarUrlObj.hash,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * MWalletTransfersApi - functional programming interface
 * @export
 */
export const MWalletTransfersApiFp = function(configuration?: Configuration) {
    return {
        /**
         * 
         * @summary Do a wallet transfer
         * @param {number} tenantId 
         * @param {EclipseTransfer} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async tenantsTenantIdWalletsTransfersPost(tenantId: number, body?: EclipseTransfer, options?: any): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<void>> {
            const localVarAxiosArgs = await MWalletTransfersApiAxiosParamCreator(configuration).tenantsTenantIdWalletsTransfersPost(tenantId, body, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * MWalletTransfersApi - factory interface
 * @export
 */
export const MWalletTransfersApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * 
         * @summary Do a wallet transfer
         * @param {number} tenantId 
         * @param {EclipseTransfer} [body] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        tenantsTenantIdWalletsTransfersPost(tenantId: number, body?: EclipseTransfer, options?: any): AxiosPromise<void> {
            return MWalletTransfersApiFp(configuration).tenantsTenantIdWalletsTransfersPost(tenantId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * MWalletTransfersApi - object-oriented interface
 * @export
 * @class MWalletTransfersApi
 * @extends {BaseAPI}
 */
export class MWalletTransfersApi extends BaseAPI {
    /**
     * 
     * @summary Do a wallet transfer
     * @param {number} tenantId 
     * @param {EclipseTransfer} [body] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof MWalletTransfersApi
     */
    public tenantsTenantIdWalletsTransfersPost(tenantId: number, body?: EclipseTransfer, options?: any) {
        return MWalletTransfersApiFp(this.configuration).tenantsTenantIdWalletsTransfersPost(tenantId, body, options).then((request) => request(this.axios, this.basePath));
    }
}
